import Close from '@/app/_components/ui/icons/Close.svg';

export default function ModalHeader({ title, CloseModal }) {
  return (
    <div>
      <div className="border-b-200 flex justify-between  p-5 pb-1 ">
        <p>{title}</p>
        <button className="" onClick={CloseModal}>
          <Close />
        </button>
      </div>
      <div className="pt-2 pb-4">
        <div className="w-full border-t border-light-gray-200"></div>
      </div>
    </div>
  );
}
